import dayjs from '../../assets/helpers/dayjs';

export default ({ value }, ageLimit, format) => {
  let pass = true;
  pass = validateDate(value, ageLimit, format);

  return pass;
};

const validateDate = (value, compare, format) => {
  const birthDate = dayjs(value, format);
  const now = dayjs();
  const age = now.diff(birthDate, 'year', true);

  return age >= compare;
};
